"use client";

import Image from "next/image";
import * as React from "react";

import { cn } from "@workspace/ui";
import { Card } from "@workspace/ui/components/card";
import { Icons } from "@workspace/ui/components/icons";

import { DiscordCta } from "~/components/common/cta/discord";
import { SectionHeadingBadge } from "~/components/common/layout/section";

import { HighlighterItem, HighlightGroup } from "./highlighter";

interface CommunityCtaProps {
  readonly className?: string;
}

export const CommunityCta = ({ className }: CommunityCtaProps) => (
  <Card
    className={cn(
      "@container relative mx-auto my-10 w-full overflow-hidden sm:my-12 md:my-16 lg:my-20",
      className,
    )}
  >
    <HighlightGroup className="group h-full">
      <div className="group/item relative h-full md:col-span-6 lg:col-span-12">
        <HighlighterItem className="p-6">
          {/* <Particles
              className="absolute inset-0 z-20 opacity-30 transition-opacity duration-1000 ease-in-out group-hover/item:opacity-100"
              quantity={400}
              color={"#ffffff"}
              vy={-0.2}
            /> */}
          <div className="relative z-20 grid grid-cols-1 gap-6 p-6 pt-0 @2xl:grid-cols-2 @2xl:p-10 @4xl:p-12">
            <div className="relative aspect-[5/2] @2xl:order-last">
              <div className="absolute -top-2 left-1/2 w-[160%] -translate-x-1/2 [mask-image:linear-gradient(to_top,transparent,hsl(var(--card))_65%)] @2xl:-top-14 @2xl:left-[80%] @2xl:w-[55rem] @4xl:-top-16 @4xl:left-1/2">
                <div className="relative">
                  <Icons.WorldMapDots className="absolute inset-0" />
                  <Image
                    src="/images/landing/world-map.png"
                    width={1000}
                    height={477}
                    alt="world map"
                    className="select-none"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-center gap-2 @2xl:gap-3">
              <SectionHeadingBadge icon={Icons.UserGroup} text="Community" />

              <h3 className="mt-3 text-2xl leading-tight font-medium tracking-tight sm:text-3xl md:text-4xl">
                Connect with like-minded people
              </h3>

              <p className="text-muted-foreground mb-3 max-w-2xl text-pretty">
                Join our community to get feedback, support, and grow together
                with 1,000+ builders on board, let's ship it!
              </p>

              <DiscordCta
                className="w-full rounded-full @2xl:w-auto"
                source="community_tile"
              />
            </div>
          </div>
        </HighlighterItem>
      </div>
    </HighlightGroup>
  </Card>
);
